module.exports = __webpack_public_path__ + "static/media/navigation-arrow-down.b9d0f462.svg";